<template>
    <div v-if="show" class="docs-modal-shadow" @click.self="closeModal">
        <div class="docs-modal">
			<div class="modal-content">
				<slot name="title"></slot>
				<slot name="body"></slot>
				<slot name="footer"></slot>
				<input type="hidden" id="modalData" v-bind:value="modaldata">
			</div>
        </div>
        
    </div>
</template>
 
<script>
    export default {
        name: "ModalWindow",
		data: function () {
            return {
                show: false,
                modaldata: ''
            }
        },
        methods: {
            closeModal: function () {
                this.show = false
            }
        }
    }
</script>
 
<style scoped
       lang="scss">
    .docs-modal-shadow {
        position: absolute;
        top: 0;
        left: 0;
        min-height: 100%;
        width: 100%;
        background: rgba(0, 0, 0, 0.15);
    }
 
    .docs-modal {
        min-width: 420px;
        max-width: 480px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
		z-index: 100;
    }
	
</style>